import React from 'react';
import classes from './footer.module.css';
import NewsLetter from './newsLetter/newsLetter';
import FooterNavigation from './footerNavigation/footerNavigation';

const Footer = (props) => {
    return (
        <div className={classes.Footer}>
            <NewsLetter newsLetterSections={props.newsLetterSections}/>
            <FooterNavigation socialLinks={props.socialLinks} quickLinks={props.quickLinks} contactInfo={props.contactInfo}/>
        </div>
    )
}
export default Footer;